<div class="research-card mt-2 mb-3">
  <div class="row align-items-center">
    <div class="col-md-5 col-lg-4 col-12 nv-border-right">
      <div class="row align-items-center">
        <div class="col-md col-10">
          <kendo-dropdownlist
            [(ngModel)]="selectedCompany"
            [data]="companyList"
            textField="companyName"
            [filterable]="true"
            (filterChange)="handleCompanyFilter($event)"
            valueField="companyName"
            [defaultItem]="{ id: null, companyName: 'Click here to select a company' }"
            (ngModelChange)="selectionChange($event)"
          >
          </kendo-dropdownlist>
        </div>
        <div class="col-md-auto col-2">
          <app-add-to-watchlist [selectedCompany]="selectedCompany" [darkMode]="darkMode"></app-add-to-watchlist>
        </div>
      </div>
    </div>
    <div class="col-md-5 col-lg-4 col-12 nv-border-right">
      <div class="row">
        <div class="graph-div d-none d-sm-block d-md-block"></div>
        <div class="col-12 col-sm-auto m-auto text-center text-md-left" style="padding: 0px">
          <span class="share-price"
            >BDT<span>{{ sharePriceDetails?.todayClosePrice | number : 2 : true }}</span></span
          >

          <span
            [hidden]="sharePriceDetails?.sharePriceDiff === null"
            class="share-price-l ml-1 {{ sharePriceDetails?.sharePriceDiff < 0 ? 'negative-r' : 'positive-r success' }}"
          >
            {{ sharePriceDetails?.sharePriceDiff > 0 ? '+' : '' }}{{ sharePriceDetails?.sharePriceDiff | number : 2 : true }}</span
          >

          <span
            [hidden]="sharePriceDetails?.gainPercentage === null"
            class="share-price-l ml-1 {{ sharePriceDetails?.sharePriceDiff < 0 ? 'negative-r negative' : 'positive success' }}"
          >
            (<i class="fa {{ sharePriceDetails?.sharePriceDiff > 0 ? ' fa-arrow-up' : ' fa-arrow-down' }}"></i
            >{{ sharePriceDetails?.gainPercentage | number : 2 : true }} %)</span
          >
        </div>
      </div>
    </div>
    <div class="col-md-2 col-lg-1 col-sm-4 col-4 nv-border-right stock-image text-center d-none d-sm-block d-md-block">
      <span class="inline-loader loader-xs loader blue" [hidden]="!sharepriceInfoInProgress"></span>
      <img
        *ngIf="!sharepriceInfoInProgress && selectedCompany"
        [src]="'../assets/images/research-portal/cse-logos/' + selectedCompany?.companyName + '.svg'"
        onError="this.src='../../assets/images/default-company-pic.png'"
      />
    </div>
    <div [hidden]="!selectedCompany" class="col-sm-8 col-md-12 col-lg-3 col-12 font-12">
      <div class="stock-image d-block d-sm-none">
        <span class="inline-loader loader-xs loader blue" [hidden]="!sharepriceInfoInProgress"></span>
        <img
          *ngIf="!sharepriceInfoInProgress && selectedCompany"
          [src]="'../assets/images/research-portal/cse-logos/' + selectedCompany?.companyName + '.svg'"
          onError="this.src='../../assets/images/default-company-pic.png'"
        />
        <div style="display: inline-block; vertical-align: middle">
          <span>Sector-{{ overviewData?.sector }}</span>
          <br />
          <span>Industry-{{ overviewData?.inductry }}</span>
        </div>
      </div>
      <div class="d-none d-sm-block d-md-block">
        <span>Sector-{{ overviewData?.sector }}</span>
        <br />
        <span>Industry-{{ overviewData?.inductry }}</span>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 {{ activeRightSide ? 'col-md-7 col-lg-8' : '' }} pr-md-2">
    <div class="research-card {{ activeRightSide && 'same-height' }}">
      <ul class="mini-tabs">
        <li [routerLinkActive]="['active']" routerLink="/research-portal/stocks/overview">Overview</li>
        <li [routerLinkActive]="['active']" routerLink="/research-portal/stocks/historical-data">Historical Data</li>
      </ul>

      <router-outlet *ngIf="!activeRightSide" #outlet="outlet"></router-outlet>

      <div class="row">
        <div class="col-12">
          <app-stock-overview
            *ngIf="activeRightSide"
            [selectedCompany]="selectedCompany"
            [companyList]="companyListMaster"
            [chartIndex]="chartIndexTypesMaster"
            [sharePrice]="sharePriceDetails"
            (sparkLineData)="receivedSparkLineData($event)"
          ></app-stock-overview>
        </div>
      </div>
    </div>
    <div [hidden]="!activeRightSide || !selectedCompany" class="research-card mt-4">
      <div class="font-12 mt-3" style="display: flex; flex-wrap: wrap">
        <div class="me-3" style="align-self: center">
          <img onError="this.src='../../assets/images/default-company-pic.png'" />
          <img
            [src]="'../assets/images/research-portal/cse-logos/' + selectedCompany?.companyName + '.svg'"
            onError="this.src='../../assets/images/default-company-pic.png'"
          />
          <span class="ml-2">{{ overviewData?.stockName }}</span>
          <br />
          &nbsp;
        </div>
        <div class="" style="align-self: center">
          <span>Sector-{{ overviewData?.sector }}</span>
          <br />
          <span>Industry-{{ overviewData?.inductry }}</span>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <div class="company-summary">
            <p>{{ overviewData?.profile }}</p>
          </div>
        </div>
        <div class="col-12">
          <div class="dotted-loader" [hidden]="!loadingOverview"></div>
          <div class="row flex-container no-gutters" [hidden]="loadingOverview">
            <div class="col-12 col-sm-6 col-md-3">
              <label>Market Cap</label>
              <b>{{ this.overviewData?.marketCap }}</b>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <label>52 Week Range</label>
              <b>{{ overviewData?.highLow52Week || 'N/A' }}</b>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <label>3M Average Turnover</label>
              <b>{{ this.overviewData?.avgTo3Mon | money }}</b>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <label>TTM EPS</label>
              <b>{{ overviewData?.eps | money }}</b>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <label>TTM P/E</label>
              <b>{{ overviewData?.pteTtm | money }}</b>
            </div>

            <div class="col-12 col-sm-6 col-md-3">
              <label>Dividend Yield</label>
              <b> {{ overviewData?.divYield | money }} <span *ngIf="(overviewData?.dividendYeild | money) !== 'N/A'">%</span></b>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [hidden]="!activeRightSide" class="col-12 col-md-5 col-lg-4 mt-4 mt-md-0 pl-md-2">
    <div class="research-card {{ activeRightSide && 'same-height' }}">
      <div class="row">
        <div class="col-auto">
          <ul class="mini-tabs">
            <li (click)="activeTab('secCActiveTab', 'rsi')" [ngClass]="secCActiveTab === 'rsi' ? 'active' : ''">RSI Graph</li>
          </ul>
        </div>
        <div class="duration-selection col" style="align-self: center">
          <ul>
            <li (click)="durationChanged('1M')" class="{{ selectedDuration === '1M' ? 'active' : '' }}">1M</li>
            <li (click)="durationChanged('6M')" class="{{ selectedDuration === '6M' ? 'active' : '' }}">6M</li>
            <li (click)="durationChanged('1Y')" class="{{ selectedDuration === '1Y' ? 'active' : '' }}">1Y</li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-rsi-graph [hidden]="secCActiveTab !== 'rsi'" [fromDate]="fromDate" [toDate]="toDate" [selectedCompany]="selectedCompany">
          </app-rsi-graph>
        </div>
      </div>
    </div>
  </div>
</div>
